import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Packages from "./pages/Packages";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ThankYou from "./pages/ThankYou";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import ClubPage from "./pages/ClubPage";
import Trainings from "./pages/Trainings";
import TrainingDetail from "./pages/TrainingDetail";
import Events from "./pages/Events";
import Shop from "./pages/Shop";
import Admin from "./pages/Admin";
import ChineseAstrology from "./pages/ChineseAstrology";
import Quiz from "./pages/Quiz";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/join" element={<Packages />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/zenergize-holistic-health-club" element={<ClubPage />} />
          <Route path="/trainings" element={<Trainings />} />
          <Route path="/trainings/:id" element={<ProtectedRoute><TrainingDetail /></ProtectedRoute>} />
          <Route path="/events" element={<Events />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/chinese-astrology" element={<ChineseAstrology />} />
          <Route path="/quiz/:key" element={<Quiz />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
